export default __webpack_public_path__ + "static/media/288.018fadee.gif";